import { useState } from "react";
import MainLayout from "../layout/MainLayout";
import ArreaListPage from "./ArreaListPage";
import ClientList from "./ClientList";

const List = () =>{

    const [active,setActive] = useState(1)

    return(
        <MainLayout>
            <div className="p-5">
                  <div className="flex justify-center items-center">
            <button className={`py-2 px-3  rounded-s-full ${active === 1 ? "bg-indigo-500 text-white":"bg-indigo-100 text-indigo-500"}  w-28`} onClick={()=>setActive(1)}>Arreas</button>
            <button className={`py-2 px-3  rounded-e-full ${active === 2 ? "bg-indigo-500 text-white":"bg-indigo-100 text-indigo-500"}  w-28`} onClick={()=>setActive(2)}>Client</button>
           </div>

           {active === 1 ? <ArreaListPage/> : <ClientList/>}
            </div>
        </MainLayout>
    );
}
export default List